import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import {
  handleInsiderPlusDeepLink,
  handleInsiderPlusEntry,
} from './util/helpers/insiderPlusEntryHelper';
import { addHeaderToken } from './request';
import { authScopeStringGetHelper } from './util/helpers/authScopeHelpers';
import { JWT_TOKEN } from './constants/localStorage';

import './i18n';

// [Insider+] Detect the ?InsiderPlusClicked=yes outer-portal deep-link and seed
// LANDING_PAGE synchronously BEFORE the first render. AuthRoute redirects an
// already-authenticated user via landingPageHelper() during render, so seeding
// this in a post-render effect (as useInitHook did) loses the race: the redirect
// reads an empty LANDING_PAGE, falls back to BUY_PAGE, and the user never lands
// on /insider-plus. Running it here guarantees LANDING_PAGE is set in time.
// handleInsiderPlusDeepLink runs first so a URL carrying both a deep path and
// ?InsiderPlusClicked=yes still resolves the deep path before the plain entry
// handler rewrites the URL again.
handleInsiderPlusDeepLink();
handleInsiderPlusEntry();

// Restore the axios Authorization header synchronously BEFORE the first render.
// useInitHook also does this, but from a post-render effect — and React runs
// child effects before parent effects, so a deep child that fires an
// authenticated request from its own mount effect (e.g. a persisted modal
// reopening on refresh) races ahead of it, 401s, and gets the user logged out.
// Setting the header here guarantees it's present before any component renders.
const persistedJwtToken = authScopeStringGetHelper(JWT_TOKEN);
if (persistedJwtToken) {
  addHeaderToken(persistedJwtToken);
}

ReactDOM.render(
  <HelmetProvider>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </HelmetProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
